import axios from 'axios';
import { fetchAuthSession } from '@aws-amplify/auth';

// API base URL
const API_BASE_URL = process.env.REACT_APP_COMSOL_API_BASE_URL;
console.log('REACT_APP_COMSOL_API_BASE_URL' ,API_BASE_URL)

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Enable CORS credentials if needed (for cookies/auth)
  withCredentials: false,
});

// Add request interceptor for authentication and logging
apiClient.interceptors.request.use(async config => {
  try {
    // Get the current authenticated user's session
    const session = await fetchAuthSession();
    // Add the ID token to the Authorization header
    if (session && session.tokens && session.tokens.idToken) {
      const idToken = session.tokens.idToken.toString();
      config.headers['Authorization'] = `Bearer ${idToken}`;
    }
  } catch (error) {
    // If there's no authenticated session, continue without auth header
    console.log('No active auth session', error);
  }
  
  // Log request details for debugging
  console.log(`Making ${config.method} request to ${config.url}`);
  return config;
});

// API service object with methods for different endpoints
const apiService = {
  // Get all ASG instances
  getASGInstances: async () => {
    try {
      const response = await apiClient.get('/asg');
      console.log('API response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching ASG instances:', error);
      // Add more detailed error logging
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
        console.error('Error response headers:', error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error request:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error message:', error.message);
      }
      throw error;
    }
  },

  // Get ASG size
  getASGSize: async () => {
    try {
      const response = await apiClient.get('/asg-size');
      console.log('ASG size response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching ASG size:', error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
      } else if (error.request) {
        console.error('Error request:', error.request);
      } else {
        console.error('Error message:', error.message);
      }
      throw error;
    }
  },
  
  // Scale ASG up or down
  scaleASG: async (action) => {
    try {
      const response = await apiClient.post('/scale', { action });
      console.log('Scale ASG response:', response);
      return response.data;
    } catch (error) {
      console.error(`Error scaling ASG ${action}:`, error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
      } else if (error.request) {
        console.error('Error request:', error.request);
      } else {
        console.error('Error message:', error.message);
      }
      throw error;
    }
  },
  
  // Terminate a specific instance
  terminateInstance: async (instanceId) => {
    try {
      const response = await apiClient.post('/instance', {
        instance_id: instanceId,
        action: 'down'
      });
      console.log('Terminate instance response:', response);
      return response.data;
    } catch (error) {
      console.error(`Error terminating instance ${instanceId}:`, error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
      } else if (error.request) {
        console.error('Error request:', error.request);
      } else {
        console.error('Error message:', error.message);
      }
      throw error;
    }
  }
};

export default apiService;
